import { useEffect } from "react";

// <title> of public/index.html: the title of the home page and of the pages with none
// of their own. It is repeated here because document.title is not always it: the
// server sends a page that is opened directly with that page's title already in
// <title> (backend/utils/pageHead.js, whose test keeps the two alike).
const HOME_TITLE = "Cloud Print — PDF файл, зургаа QR кодоор киоскоос хэвлэ";

// A page with its own title puts it in front of the site name and gives the home
// title back on leaving.
const usePageTitle = (title) => {
  useEffect(() => {
    if (!title) return undefined;
    document.title = title + " — Cloud Print";
    return () => {
      document.title = HOME_TITLE;
    };
  }, [title]);
};

export default usePageTitle;
